import { Grid, Label, Loader } from "@aws-amplify/ui-react";
import { CCard } from "@coreui/react";
import { useEffect, useState } from "react";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { API, graphqlOperation } from "aws-amplify";
import moment from "moment";

import {
  getBranch,
  getCompany,
  getDevice,
} from "graphql/queries";

const EquipmentInfo = ({ equipment }) => {
  const [company, setCompany] = useState({ data: {}, loading: false });
  const [branch, setBranch] = useState({ data: {}, loading: false });
  const [device, setDevice] = useState({ data: {}, loading: false });

  const getCompanyName = async (id) => {
    try {
      setCompany({ data: {}, loading: true });

      const companyData = await API.graphql(
        graphqlOperation(getCompany, { id })
      );
      const companyDataItem = companyData.data.getCompany;

      setCompany((prev) => ({ ...prev, data: companyDataItem }));
    } catch (err) {
      toast.error(strings.errors.fetchCompany);
    } finally {
      setCompany((prev) => ({ ...prev, loading: false }));
    }
  };

  const getBranchName = async (id) => {
    try {
      setBranch({ data: {}, loading: true });

      const branchData = await API.graphql(graphqlOperation(getBranch, { id }));
      const branchDataItem = branchData.data.getBranch;

      setBranch((prev) => ({ ...prev, data: branchDataItem }));
    } catch (err) {
      toast.error(strings.errors.fetchBranch);
    } finally {
      setBranch((prev) => ({ ...prev, loading: false }));
    }
  };

  const getDeviceName = async (id) => {
    try {
      setDevice({ data: {}, loading: true });

      const deviceData = await API.graphql(
        graphqlOperation(getDevice, { id })
      );
      const deviceDataItem = deviceData.data.getDevice;

      setDevice((prev) => ({ ...prev, data: deviceDataItem }));
    } catch (err) {
      toast.error(strings.errors.fetchDevice);
    } finally {
      setDevice((prev) => ({ ...prev, loading: false }));
    }
  };

  useEffect(() => {
    if (equipment.companyID) getCompanyName(equipment.companyID);
    if (equipment.branchID) getBranchName(equipment.branchID);
    if (equipment.deviceID) getDeviceName(equipment.deviceID);
  }, [equipment]);

  return (
    <CCard
      className="p-3"
      borderRadius="medium"
      variation="outlined"
      style={{ height: "100%" }}
    >
      <Grid gap="5px">
        <span className="fs-5">{strings.equipment}</span>
        <Grid
          gap="25px"
          templateColumns={{ base: "1fr", xl: "1fr 1fr 1fr" }}
        >
          <Grid>
            <Label>{strings.company}</Label>
            {company.loading ? (
              <Loader />
            ) : (
              <span className="text-muted">{company.data.name}</span>
            )}
          </Grid>
          <Grid>
            <Label>{strings.branch}</Label>
            {branch.loading ? (
              <Loader />
            ) : (
              <span className="text-muted">{branch.data.name}</span>
            )}
          </Grid>
          <Grid>
            <Label>{strings.device}</Label>
            {device.loading ? (
              <Loader />
            ) : (
              <span className="text-muted">{device.data.name}</span>
            )}
          </Grid>
          <Grid>
            <Label>{strings.name}</Label>
            <span className="text-muted">{equipment.name}</span>
          </Grid>
          <Grid>
            <Label>{strings.description}</Label>
            <span className="text-muted">{equipment.description}</span>
          </Grid>
          <Grid>
            <Label>{strings.createdAt}</Label>
            <span className="text-muted">
              {moment(equipment.createdAt).format("YYYY-MM-DD HH:mm:ss")}
            </span>
          </Grid>
        </Grid>
      </Grid>
    </CCard>
  );
};

const strings = new LocalizedStrings({
  es: {
    equipment: "Datos del Equipo",
    name: "Nombre",
    description: "Descripción",
    company: "Empresa",
    branch: "Sede",
    device: "Dispositivo",
    createdAt: "Fecha de creación",
    errors: {
      fetchCompany: "Error al consultar la empresa",
      fetchBranch: "Error al consultar la sede",
      fetchDevice: "Error al consultar el dispositivo",
    },
  },
});

export default EquipmentInfo;
